export default [
  {
    path: "/materi/ringkasan-materi",
    name: "ringkasan-materi",
    component: () => import("@/views/menu/materi/ringkasan-materi"),
    meta: {
      pageTitle: "Materi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Ringkasan Materi",
          active: true,
        },
      ],
    },
  },
  {
    path: "/materi/detail-ringkasan-materi/:id",
    name: "detail-ringkasan-materi",
    component: () => import("@/views/menu/materi/ringkasan-materi/detail"),
    meta: {
      pageTitle: "Materi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Ringkasan Materi",
          active: false,
          to: { name: "ringkasan-materi" },
        },
        {
          text: "Detail Ringkasan Materi",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ebook",
    name: "ebook",
    component: () => import("@/views/menu/materi/ebook/index.vue"),
    meta: {
      pageTitle: "Materi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "E-Book",
          active: true,
        },
      ],
    },
  },

  {
    path: "/detail-ebook/:id",
    name: "detail-ebook",
    component: () => import("@/views/menu/materi/ebook/list-ebook"),
    meta: {
      pageTitle: "Materi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "E-Book",
          active: false,
          to: { name: "ebook" },
        },
        {
          text: "Detail E-Book",
          active: true,
        },
      ],
    },
  },
];
